<!--
  PersonRow: person line with initials avatar, name, subtitle and contact links (Ansprechpartner, Eltern, Kinder, Lehrkräfte).
  Props: name, subtitle, initials (default: from name), tone (avatar colour), contacts ({ icon, text, href }[]), to (router
         link on the name)
  Slots: actions (right side), default (extra lines below the contacts)
-->
<template>
  <div class="pui-person">
    <span :class="`tone-${tone}`" class="acq-avatar acq-avatar--sm">{{ initials || initialsOf(name) }}</span>
    <div class="flex-grow-1" style="min-width: 0">
      <router-link v-if="to" :to="to" class="pui-person__name pui-person__link text-truncate d-block">{{ name }}</router-link>
      <div v-else class="pui-person__name text-truncate">{{ name }}</div>
      <div v-if="subtitle" class="acq-tiny text-truncate">{{ subtitle }}</div>
      <div v-if="contacts.length" class="d-flex flex-wrap mt-1" style="gap: 4px 10px">
        <a v-for="(el, i) in contacts" :key="i" :href="el.href" class="pui-person__contact">
          <v-icon x-small>{{ el.icon }}</v-icon>{{ el.text }}
        </a>
      </div>
      <slot/>
    </div>
    <div v-if="$slots.actions" class="d-flex align-center" style="gap: 2px">
      <slot name="actions"/>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {initialsOf} from './profileUi.helper';

export interface PersonContact {
  icon: string;
  text: string;
  href: string;
}

export default Vue.extend({
  props: {
    name: {type: String, required: true},
    subtitle: {type: String, default: ''},
    initials: {type: String, default: ''},
    tone: {type: String, default: 'info'},
    contacts: {type: Array as () => PersonContact[], default: () => []},
    to: {type: [String, Object], default: null},
  },
  methods: {
    initialsOf,
  },
});
</script>

<style scoped>
.pui-person__link {
  color: inherit !important;
  text-decoration: none;
}

.pui-person__link:hover {
  color: #1565C0 !important;
}
</style>
<style src="@/components/acquisitionList/ui/acquisitionViews.css"></style>
<style src="@/components/common/modern/modern.css"></style>
<style src="@/components/acquisitionList/ui/itemDetails.css"></style>
<style src="./profileUi.css"></style>
